import { Grid, LinearProgress } from '@mui/material';

interface StepsTopBarProps {
  step: number;
  totalSteps: number;
}

export const StepsTopBar = ({ step, totalSteps }: StepsTopBarProps) => {
  const progress = (step / totalSteps) * 100;

  return (
    <Grid
      style={{
        top: 20,
        left: 20,
        right: 20,
        zIndex: 1,
        position: `absolute`,
      }}
    >
      {step > 0 ? <LinearProgress variant="determinate" value={progress} style={{ borderRadius: `50px` }} /> : null}
    </Grid>
  );
};
